import React from 'react'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import styled from 'styled-components';
import { useLocalizedFormatters } from 'i18n/useLocalizedFormatters'

export default function ChurchTransactionItem(props) {
    const { formatCurrency, formatDate } = useLocalizedFormatters()

    return (
        <tr>
            <td>{formatDate(props.data.created * 1000)}</td>
            <td>{formatCurrency(props.data.amount)}</td>
            <td>{props.data.description} </td>
            <td>  {props.data.receipt_email}  </td>
            {/* <td>  {props.data.status}  </td> */}
           
            {/* <RecTd>
            <a style={{color: 'var(--themeColor)'}} href={`${props.data.receipt_url}`} target="_blank" rel="noreferrer">
                <ReceiptLongIcon />
            </a>
            <span className='recT'> View Receipt </span>
            </RecTd> */}
        </tr>
    )
}

const RecTd = styled.td`
  .recT{
    position: absolute;
    padding: 5px;
    display: none;
    width: fit-content;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: #00000063;
    color: white;
    margin-bottom: 5px;
    margin-left: 5px;
    border-radius: 5px 5px 5px 0px;
    font-size: x-small;
    white-space: nowrap;
  }

  &:hover{
    .recT{
      display: unset;
    }
  }

`

const Rfnd = styled.div`
  display: inline;
  color: white;
  font-size: 10px;
  padding: 3px;
  border-radius: 2px;
  background-color: #8d0202b0;
`
